import { EventCardProps, UI_EventCard } from 'ui/components/2-molecules/Card/EventCard/EventCard';
import styles from './DocumentOverview.module.scss';
import { UI_Button } from 'ui/components/1-atoms/Action/Button/Button';

export interface DocumentOverviewProps {
	cards: EventCardProps[];
	paginationText: string;
	requestMoreCards?: () => void;
}

export const UI_DocumentOverview = ({ cards, paginationText, requestMoreCards }: DocumentOverviewProps) => {
	return (
		<div className={styles.DocumentOverview}>
			{cards?.map((card, index) => {
				return <UI_EventCard className={styles.DocumentOverview_card} key={index} {...card} />;
			})}
			{paginationText && (
				<div className={styles.DocumentOverview_pagination}>
					<UI_Button style="secondary" onClick={requestMoreCards}>
						{paginationText}
					</UI_Button>
				</div>
			)}
		</div>
	);
};
